import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilderFielditemComponent } from 'src/app/shared/components/form-builder-fielditem/form-builder-fielditem.component';
import { BuyerInfoStep } from 'src/app/shared/product/buyerInfoStep';
import { AuthService } from 'src/app/shared/services/auth.service';
import { LanguageService } from 'src/app/shared/services/language.service';
import { ProductStepHandlingService } from '../../../payment-pages/services/product-step-handling.service';
import { GetCustomPaymentBuyerInfo } from '../../services/getCustomPaymentBuyerInfo.service';
import { UpdateCustomPaymentBuyerInfo } from '../../services/updateCustomPaymentBuyerInfo.service';
import { CustomPaymentBuyerInfoDataTransform } from './CustomPaymentBuyerInfoDataTransform.service';
import { DeleteCustomPaymentBuyerInfo } from '../../services/deleteCustomPaymentBuyerInfo.service';

@Component({
  selector: 'app-custom-payment-buyer-ifno-setting',
  templateUrl: './custom-payment-buyer-ifno-setting.component.html',
  styleUrls: ['./custom-payment-buyer-ifno-setting.component.scss'],
})
export class CustomPaymentBuyerIfnoSettingComponent
  extends BuyerInfoStep
  implements OnInit, AfterViewInit
{
  stepForm!: FormGroup;
  isBuyerInfoFormValid=false;
  @ViewChild(FormBuilderFielditemComponent)
  FormBuilder!: FormBuilderFielditemComponent;
  constructor(
    public fb: FormBuilder,
    private translate: TranslateService,
    private languageService: LanguageService,
    private getBuyerInfo: GetCustomPaymentBuyerInfo,
    private authServ: AuthService,
    private updateBuyerIfno: UpdateCustomPaymentBuyerInfo,
    private deleteBuyerIfno:DeleteCustomPaymentBuyerInfo,
    private stepHandlerService:ProductStepHandlingService,
    private buyerInfoDataTransformer:CustomPaymentBuyerInfoDataTransform
  ) {
    super(fb);
  }
  async ngOnInit() {
    this.stepHandlerService.isBuyerInfoFormValid.subscribe(value => {
      this.isBuyerInfoFormValid = value
    })
    this.translate.use(localStorage.getItem('language'));
    this.languageService.languageUpdated.subscribe((lang: string) => {
      this.translate.use(lang);
    });
    super.ngOnInit();
    try {
      const businessId = (await this.authServ.getBusiness()).id;
      this.getBuyerInfo.setParams({ businessId: businessId });
      const res:CustomPaymentBuyerInfoResponse = await this.getBuyerInfo.make();
      if (res.found) {

        const BuyerInfoFieldsAndValues = this.buyerInfoDataTransformer.transformIncomingValues(
          res.result.BuyerInfoFields
        );
        const BuyerInfoFields=this.prepareInComingBuyerInfoFieldsValues(BuyerInfoFieldsAndValues);
        this.populateBuyerInfoFields({ BuyerInfoFields });
      }
    } catch (err) {
      console.log(err);
    }
  }

  async submit() {
    const buyerInfoFields =this.buyerInfoDataTransformer.prepareOutPutData(this.stepForm.value.buyerInfos);
    if(buyerInfoFields.length <=0 ){
      await this.deleteBuyerIfno.make();
    }else{
      this.updateBuyerIfno.setParams({ buyerInfos: buyerInfoFields });
      await this.updateBuyerIfno.make();
    }
  }
  prepareInComingBuyerInfoFieldsValues(existingResultBuyerInfo:buyerInfoFormFileds[]) {
    return existingResultBuyerInfo.map((res) => {
      return {
        fieldRequired:res.fieldRequired,
        FieldTypeId: res.fieldType,
        name: res.fieldName,
        BuyerInfoFieldOptions: res.value,
      };
    });
  }

}

interface CustomPaymentBuyerInfo{
  id: number,
  BuyerInfoFields: string,
  BusinessId: number,
  createdAt: string,
  updatedAt: string
}
export interface buyerInfoFormFileds{
  fieldRequired:boolean;
  fieldType:string;
  id:string;
  fieldName:string;
  value:{id:string,name:string}[];
}
export interface CustomPaymentBuyerInfoResponse{
  found:boolean,
  result:CustomPaymentBuyerInfo
}
